import React, { useEffect, useRef, useState } from "react";
import { IoShapesSharp } from "react-icons/io5";
import Avatar from "../../../design-system/Avatar";
import { RenderResponse } from "./RenderResponse";
import { RenderCitations } from "./RenderCitations";
import { ChatCardButton } from "./ChatCardButton";
import { getInitials } from "../../../utils/common";

export type ChatCardProps = {
    prompt?: string;
    response?: null | string | string[] | JSX.Element[] | JSON;
    citations?:
        | null
        | string
        | string[]
        | JSX.Element[]
        | { text: string; link: string }
        | { text: string; link: string }[]
        | Array<{ citation: string; link: string; title: string; author: string }>;
    flagForCaselet?: boolean;
    isLoading?: boolean;
    responseForFineTune?: string;
    conversation_id?: string;
    onCitationClick?: (path: string) => void;
    from?: string;
    isOldInteractions?: boolean;
};

const ChatCard: React.FC<ChatCardProps> = ({
    prompt,
    response,
    citations,
    flagForCaselet,
    responseForFineTune,
    conversation_id,
    onCitationClick,
    from,
    isOldInteractions
}: ChatCardProps) => {
    const isLoading = response === null || response === "" || response === "";
    const [showCitationSource, setShowCitationSource] = useState(false);
    const handleCitationClick = () => {
        setShowCitationSource(true);
    };

    let userData: any = localStorage.getItem("user_data");
    if (userData) {
        try {
            userData = JSON.parse(userData);
            // console.log("userData: ", userData);
        } catch (e) {
            console.error("Error parsing user_data from localStorage:", e);
            userData = null; // or set a default object if needed
        }
    } else {
        userData = null;
        // or set a default object if needed
    }
    const userName = userData ? userData.name : "John Doe";
    const lastCardRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (lastCardRef.current) {
            const elementRect = lastCardRef.current.getBoundingClientRect();
            const headerHeight = 60; // Adjust based on your fixed header height

            window.scrollTo({
                top: elementRect.top + window.pageYOffset - headerHeight,
                behavior: "smooth"
            });
        }
    }, [isLoading]);
    const isCitationsEmpty =
        !citations ||
        (Array.isArray(citations) && citations.length === 0) ||
        (typeof citations === "object" && !Array.isArray(citations) && Object.keys(citations).length === 0);

    return (
        <div className="">
            {isOldInteractions && <div ref={lastCardRef} />}

            <div className="flex items-center p-2 ">
                {from !== "ShowInteraction" ? (
                    <div>
                        <Avatar initials={getInitials(userName)} fullName={userName} className="mr-4 " />
                    </div>
                ) : (
                    ""
                )}
                <div>
                    <p className="text-lg font-semibold ">{prompt}</p>
                </div>
            </div>
            <div className="">
                {flagForCaselet ? (
                    <div className="p-4 mb-6 rounded-lg relative bg-gray-400 min-w-[350px]">
                        <div className="bg-gray-400">
                            <div className="bg-white rounded-lg px-2">
                                {<RenderResponse isLoading={isLoading} response={response} flagForCaselet={flagForCaselet} />}
                            </div>
                            <div className="bg-green-50 rounded-lg p-2 min-h-[57.5px] flex justify-between items-center mt-5 ">
                                <div className="min-w-[100px] flex-1">
                                    <RenderCitations isLoading={isLoading} citations={citations} onCitationClick={onCitationClick} />
                                </div>
                                <div className="text-gray-100 p-2">
                                    <ChatCardButton
                                        icon={<IoShapesSharp size="24" />}
                                        text={"Fine tune as caselet"}
                                        to="/unpublished-caselets/preview"
                                        response={responseForFineTune}
                                        conversation_id={conversation_id}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="p-4 bg-gray-300 mb-6 rounded-lg relative min-w-[350px]">
                        <div className="">
                            {<RenderResponse isLoading={isLoading} response={response} flagForCaselet={flagForCaselet} />}
                            <div className="pl-2">
                                {!isCitationsEmpty && <div className="mt-5"></div>}
                                <RenderCitations
                                    isLoading={isLoading}
                                    citations={citations}
                                    onCitationClick={onCitationClick}
                                    flagForCaselet={flagForCaselet}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatCard;
